// TableRowItem.jsx
import React from "react";
import {
  TableRow,
  TableCell,
  Typography,
  IconButton,
  Box,
  Chip,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import { getIcingName, extractSizes } from "./utils";

const TableRowItem = ({
  cake,
  flavorOptions,
  icingOptions,
  sizeOptions,
  onEdit,
  onDelete,
  onMoreInfo,
}) => {
  const renderFlavorChips = () => (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {cake.flavors.map((flavorId, index) => {
        const flavor = flavorOptions.find((f) => f._id === flavorId._id);
        return (
          <Chip
            key={index}
            label={flavor ? flavor.displayName : "Unknown Flavor"}
          />
        );
      })}
    </Box>
  );

  const renderInsideIcing = () => (
    <Box>
      {cake.flavors.map((flavorId, index) => {
        const flavor = flavorOptions.find((f) => f._id === flavorId);
        const icing = icingOptions.find((i) => i._id === flavor?.icing?._id);
        return (
          <Typography key={index} variant="body2">
            {icing?.name || "Unknown Icing"}
          </Typography>
        );
      })}
    </Box>
  );

  const renderImages = () => (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {cake.flavors.map((flavorId, index) => {
        const flavor = flavorOptions.find((f) => f._id === flavorId._id);
        return (
          <img
            key={index}
            src={flavor?.images?.primary || "/default-placeholder.jpg"}
            alt={flavor ? flavor.name : "No Image"}
            style={{
              width: "80px",
              height: "80px",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        );
      })}
    </Box>
  );

  return (
    <TableRow>
      <TableCell sx={{ minWidth: 150 }}>{cake.displayName}</TableCell>
      <TableCell sx={{ maxWidth: 800 }}>{cake.description}</TableCell>
      <TableCell sx={{ maxWidth: 300 }}>{renderFlavorChips()}</TableCell>
      <TableCell sx={{ minWidth: 150 }}>
        {extractSizes(cake.sizes, sizeOptions)}
      </TableCell>
      <TableCell>{renderImages()}</TableCell>
      <TableCell align="right">
        <Tooltip title="Edit" arrow>
          <IconButton onClick={() => onEdit(cake)} sx={{ color: "#6E6E6E" }}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete" arrow>
          <IconButton
            onClick={() => onDelete(cake._id)}
            sx={{ color: "#6E6E6E" }}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="More Info" arrow>
          <IconButton
            onClick={() => onMoreInfo(cake)}
            sx={{ color: "#6E6E6E" }}>
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default TableRowItem;
